import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius3, colorBgInteractiveActive, colorGrayscaleL, space6 } = theme();

  return StyleSheet.create({
    androidInAppBrowserContainer: {
      left: "50%",
    },
    androidInAppBrowserPressable: {
      marginTop: space6,
    },
    androidInAppBrowserPressableText: {
      fontWeight: "bold",
      textAlign: "center",
      textDecorationLine: "underline",
    },
    container: {
      alignItems: "center",
      backgroundColor: colorBgInteractiveActive,
      borderRadius: borderRadius3,
      flex: 1,
      justifyContent: "center",
      overflow: "hidden",
    },
    icon: {
      color: colorGrayscaleL,
    },
    image: {
      height: "100%",
      width: "100%",
    },
  });
};

export { style };
